
import { Component, Vue, Prop } from "vue-property-decorator";
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";

@Component
class ComposeTable extends Vue {
  @Prop({ default: false }) readonly data!: ManhuntMapPoi[];
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  searchFilter = "";
  busy = false;
  currentPage = 1;
  perPage = 5;
  fields = [
    {
      key: "valid",
      label: "Valid",
      sortable: true,
    },
    {
      key: "active",
      label: "Active",
      sortable: true,
    },
    {
      key: "title",
      label: "Title",
      sortable: true,
    },
    {
      key: "challenge",
      label: "Challenge?",
      sortable: true,
    },
    {
      key: "visible",
      label: "Hidden?",
      sortable: true,
    },
    {
      key: "map_mods",
      label: "Map Mods",
      sortable: true,
    },
    {
      key: "witness",
      label: "Witness",
      sortable: true,
    },
  ];
  get getMapPoiData(): ManhuntMapPoi[] {
    return this.$store.state.mapPoiStore.mapPoi;
  }

  get totalRows(): number {
    return this.getMapPoiData.length;
  }

  getRowCssClass(item: any): string {
    if (!this.getIsValid(item)) {
      return "highlight-row";
    } else if (item.issues !== undefined && item.issues.err !== undefined) {
      return "highlight-row";
    } else {
      return "";
    }
  }

  getMapMods(item: any): string {
    if (item.map_mods !== undefined) {
      if (item.map_mods.active) {
        return item.map_mods.type;
      }
      return "-";
    } else {
      return "-";
    }
  }
  getChallenge(item: any): string {
    if (item.challenge !== undefined) {
      if (item.challenge.active) {
        return "True";
      }
      return "-";
    } else {
      return "-";
    }
  }
  getIsValid(item: any): boolean {
    if (
      item.loc.loc_uid.trim().length == 0 &&
      (item.loc.override_ll.latitude == 0 ||
        item.loc.override_ll.longitude == 0)
    ) {
      return false;
    } else {
      return true;
    }
  }
  getWitness(item: any): string {
    if (item.witness !== undefined) {
      if (item.witness.active) {
        return "True";
      }
      return "-";
    } else {
      return "-";
    }
  }

  getActive(item: any): string {
    if (item.active !== undefined) {
      if (item.active) {
        return "True";
      }
      return "-";
    } else {
      return "-";
    }
  }
  getHidden(item: any): string {
    if (item.visible !== undefined) {
      if (!item.visible) {
        return "True";
      }
      return "-";
    } else {
      return "-";
    }
  }

  filterByTitleName(row: any) {
    if (row.title.en.toLowerCase().includes(this.searchFilter.toLowerCase())) {
      return true;
    }
    return false;
  }

  onRowSelected(rows: any): void {
    //I'm not sure what type this should be. I have called any for the time being
    let myTable = this.$refs.composeTable as any;
    myTable.clearSelected();
    this.$emit("handleTableSelection", rows[0]);
  }
}

export default ComposeTable;
